import styled from 'styled-components';
import { Checkbox as SemanticCheckbox } from 'semantic-ui-react';
import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const ContainerRow = styled.div`
  display: flex;
  flex-direction: row;
  padding: 5px 0;
  ${(props) => (props.noBorder ? '' : 'border-top: 1px solid rgba(0,0,0,.1);')};
  :hover {
    background-color: ${(props) => props.theme.color.rowHover};
  }
  ${(props) => (props.isMerged ? (`
    border-left: 10px solid ${props.theme.color.primary};
    padding-left: 10px;
  `) : 'padding-left: 20px')};
`;

export const ContainerCategoryName = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`;

export const CategoryNameText = styled(TextLayoutComponent)``;

export const Checkbox = styled(SemanticCheckbox)`
  &.ui.checkbox {
    label {
      color: ${(props) => props.theme.color.textLabel};
      margin-right: 10px;
      font-weight: 500;
      word-break: break-word;
    }
  }
`;
